import { Button } from "@/client/components/shad/button";
import { Field } from "@/client/components/shad/field";
import { useFormContext } from "../form-context";

export const SubmitButton = ({ label }: { label: string }) => {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Field orientation="horizontal">
          <Button
            className="cursor-pointer"
            form="admin-config-form"
            type="submit"
            onClick={() => form.handleSubmit()}
            disabled={isSubmitting}
          >
            {label}
          </Button>
          <Button onClick={() => form.reset()} variant="outline" type="button">
            Reset
          </Button>
        </Field>
      )}
    </form.Subscribe>
  );
};
